<script>
export default {
  props: {
    highResUrl: {
      type: String,
      required: true
    },
    lowResUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      playVideo: false,
      switched: false
    }
  },

  methods: {
    showVideo() {
      // seems backwards because we're switching from a playing video to a video background
      if (this.playVideo === true) {
        // stop video, switch to background
        this.showBackgroundVideo()
      } else {
        // play video
        this.$refs.video.muted = false;
        this.$refs.video.loop = false;

        if (!this.switched) {
          this.$refs.video.setAttribute('src', this.highResUrl);
          this.$refs.video.load();
          this.$refs.video.pause()
          this.switched = true;

          // listen for end of video
          this.$refs.video.addEventListener('ended', this.showBackgroundVideo, false)
        }

        this.playVideo = true;
        this.$refs.video.play();
        this.$refs.video.controls = true;
      }
    },

    showBackgroundVideo() {
      this.playVideo = false;
      this.$refs.video.muted = true;
      this.$refs.video.setAttribute('src', this.lowResUrl);
      this.switched = false;
      this.$refs.video.loop = false;
      this.$refs.video.play();
      this.$refs.video.controls = false;
    }
  }
}
</script>

<style lang="postcss">
  .black_overlay.no-overlay::after {
    background: none;
    content: none;
  }
</style>